<template lang="html">
<div>

  <div class="slds-box slds-theme_shade">

    <ul class="slds-timeline">

      <li v-for="(record,index) in records" v-bind:key="record.Id">

        <div v-bind:class="{'slds-is-open': record.show}" class="slds-timeline__item_expandable slds-timeline__item_task ">
          <span class="slds-assistive-text">{{record.IsTask?'Task':'Event'}}</span>
          <div class="slds-media">

            <div class="slds-media__figure">
              <button v-on:click.prevent="openNote(index)" class="slds-button slds-button_icon" title="Toggle details" aria-controls="task-item-base">
                <svg class="slds-button__icon slds-timeline__details-action-icon" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#switch"></use>
                </svg>
                <span class="slds-assistive-text">Toggle details</span>
              </button>

              <div class="slds-icon_container slds-icon-standard-task slds-timeline__icon" title="task">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use v-bind:xlink:href="'/assets/icons/standard-sprite/svg/symbols.svg#'+(record.IsTask?'task':'event')"></use>
                </svg>
              </div>
            </div>

            <div class="slds-media__body">
              <div class="slds-grid slds-grid_align-spread slds-timeline__trigger">
                <div class="slds-grid slds-grid_vertical-align-center slds-truncate_container_75 slds-no-space">

                  <h3 class="slds-truncate" v-bind:title="record.Subject">
                    <a href="javascript:void(0);">
                      <strong>{{record.Subject}}</strong>
                    </a>
                  </h3>

                </div>

                <div class="slds-timeline__actions slds-timeline__actions_inline">
                  <p class="slds-timeline__date">{{record.ActivityDate | datetime}}</p>
                  <button class="slds-button slds-button_icon slds-button_icon-border-filled slds-button_icon-x-small" aria-haspopup="true" title="More Options for this item">
                    <svg class="slds-button__icon" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
                    </svg>
                    <span class="slds-assistive-text">More Options for this item</span>
                  </button>
                </div>
              </div>

              <article class="slds-box slds-timeline__item_details slds-theme_shade slds-m-top_x-small slds-m-horizontal_xx-small slds-p-around_medium" id="task-item-expanded" aria-hidden="false">
                <div>
                  <span class="slds-text-title">Type</span>
                  <p class="slds-p-top_x-small"><span v-html="record.Type"></span></p>
                </div>
                <div>
                  <span class="slds-text-title">User</span>
                  <p class="slds-p-top_x-small"><span v-html="record.Utente__c"></span></p>
                </div>
                <div>
                  <span class="slds-text-title">Description</span>
                  <p class="slds-p-top_x-small"><span v-html="record.Description"></span></p>
                </div>
              </article>

            </div>
          </div>
        </div>
      </li>

    </ul>

  </div>

</div>

</template>

<script>

export default {
  name: 'gnetTimeline',
  components: {
  },
  props: {
    records: Array
  },
  data() {
    return {
    }
  },
  mounted: function() {
  },
  filters: {
    datetime: function(dt) {
      if (dt) {
        var d = dt.substr(0, 10);
        var t = dt.substr(11, 8);
        return d + ' ' + t;
      }
      return dt;
    }
  },
  methods: {
    openNote: function(index) {
      console.log('openNote:'+index);
      this.records[index].show=!this.records[index].show;
    },
  }
}
</script>

<style lang="" scoped>

</style>
